const BASE_URL = process.env.REACT_APP_HOST_BASE_URL;

export const getCountryProviders = async (token, countryId) => {
  const response = await fetch(`${BASE_URL}/v1/country-provider/${countryId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return response.json();
};

export const createCountryProvider = async (token, body) => {
  const response = await fetch(`${BASE_URL}/v1/country-provider`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
  return response.json();
};

export const updateCountryProvider = async (token, body) => {
  const response = await fetch(`${BASE_URL}/v1/country-provider`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
  return response.json();
};

export const deleteCountryProvider = async (token, id) => {
  const response = await fetch(`${BASE_URL}/v1/country-provider/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return response.ok ? { success: true } : response.json();
};